import * as React from "react";
import styled from "styled-components";

import Tooltip, { orientation, showOn } from "@8x8/oxygen-tooltip";
import { IconButton } from "@8x8/oxygen-icon-button";
import EraserIcon from "@8x8/oxygen-icon/novo/EraserIcon";

const Container = styled.div`
  display: flex;
`;

/**
 * Tiny button displayed to the right of the customer info,
 * used to remove the currently "locked-in" customer.
 *
 * @constructor
 */
const ClearAction = ({ onClick }) => {
  return (
    <Container>
      <Tooltip
        orientation={orientation.top}
        showOn={showOn.hover}
        title="Clear the current customer"
      >
        <IconButton onClick={onClick}>
          <EraserIcon />
        </IconButton>
      </Tooltip>
    </Container>
  );
};

export default ClearAction;
